export const RIGHT_PANEL_INLINE_LAYOUT_MEDIA_QUERY = "(max-width: 980px)";
export const RIGHT_PANEL_SHEET_CLASS_NAME =
  "w-[min(42vw,28rem)] min-w-80 max-w-[28rem] p-0 max-[760px]:w-[min(88vw,24rem)] max-[760px]:min-w-0 wco:mt-[env(titlebar-area-height)] wco:h-[calc(100%-env(titlebar-area-height))] wco:max-h-[calc(100%-env(titlebar-area-height))]";

export function resolveRightPanelPresentationMode(input: {
  readonly isOpen: boolean;
  readonly hasThread: boolean;
  readonly useSheet: boolean;
}): "inline" | "sheet" | null {
  if (!input.isOpen || !input.hasThread) return null;
  return input.useSheet ? "sheet" : "inline";
}

/** The conversation and surface share the space left after workspace navigation. */
export function resolveWorkspacePanelLayout(availableWidth: number) {
  const chatMinimum = 360;
  const panelMinimum = 360;
  return {
    useSheet: availableWidth < chatMinimum + panelMinimum,
    maxPanelWidth: Math.max(panelMinimum, Math.min(1400, availableWidth - chatMinimum)),
  };
}

/** Which open surfaces a close gesture gives up. */
export type RightPanelCloseScope = "others" | "to-right" | "all";

/**
 * The surfaces a close gesture releases, so their resources can be cleaned up
 * before the store forgets them.
 *
 * `to-right` returns null when the target is no longer open: the gesture has
 * nothing to measure from, and closing everything after a surface that is gone
 * would release the wrong tabs.
 */
export function selectRightPanelSurfacesToRelease<T extends { readonly id: string }>(input: {
  readonly surfaces: ReadonlyArray<T>;
  readonly scope: RightPanelCloseScope;
  readonly targetId?: string | undefined;
}): ReadonlyArray<T> | null {
  if (input.scope === "all") return input.surfaces;
  if (input.scope === "others") {
    return input.surfaces.filter((surface) => surface.id !== input.targetId);
  }
  const targetIndex = input.surfaces.findIndex((surface) => surface.id === input.targetId);
  return targetIndex < 0 ? null : input.surfaces.slice(targetIndex + 1);
}
